/**
 * Step One Foods — Loop + UpCart Bundle Clubbing
 * Ported verbatim from current theme.liquid.
 *
 * Coordinates Loop BYO bundles with UpCart cart drawer:
 *   1. Listens for loopByobAddToCartSuccessEvent from Loop
 *   2. Calls upcartRegisterAddToCart() to open the UpCart drawer
 *   3. Calls processFirstBundleItem() to hide duplicate bundle line items
 *
 * WARNING: This code is fragile. Do not modify without regression-testing
 * the full add-bundle-to-cart flow on the theme preview URL first.
 */

// ── Add to cart success handler ────────────────────────────────────────────

function handleAddToCartSuccessEvent(event) {
  if (typeof window.upcartRegisterAddToCart === 'function') {
    window.upcartRegisterAddToCart();
    window.upcartOpenOnAddToCartOverride = true;
    var targetNode = document.getElementById('CartPopup');
    processFirstBundleItem(targetNode);
  } else {
    console.warn('[UpCart] API is not available on this page.');
  }
}

document.addEventListener('loopByobAddToCartSuccessEvent', function(event) {
  handleAddToCartSuccessEvent(event);
});

document.dispatchEvent(new CustomEvent('loopByobAddToCartSuccessEvent', {
  detail: { message: 'Item successfully added to the cart!' }
}));

// ── Cart drawer status checker ──────────────────────────────────────────────

function checkCartDrawerStatus() {
  var targetNode = document.getElementById('CartPopup');
  if (targetNode) {
    var isActive = targetNode.classList.contains('styles_active__7AzVD');
    if (isActive) {
      clearInterval(window.cartDrawerCheckInterval);
      setTimeout(async function() {
        await processFirstBundleItem(targetNode);
      }, 600);
    } else {
      console.log('[UpCart] Cart drawer is not active.');
    }
  } else {
    console.warn('[UpCart] CartPopup element not found.');
  }
}

// ── Get cart items ──────────────────────────────────────────────────────────

async function getCartItems() {
  try {
    var response = await fetch('/cart.js');
    var cart = await response.json();
    return cart.items || [];
  } catch (err) {
    console.error('[Loop+UpCart] Failed to fetch cart:', err);
    return [];
  }
}

// ── Process first bundle item (hide duplicates in drawer) ──────────────────

async function processFirstBundleItem(targetNode) {
  if (!targetNode) return;

  var cartItems = await getCartItems();
  if (!cartItems.length) return;

  // Find bundle parent items (Loop marks them with properties)
  var bundleParents = cartItems.filter(function(item) {
    return item.properties && item.properties['_loop_bundle_id'];
  });

  if (!bundleParents.length) return;

  hideBundleItems(targetNode, bundleParents);
}

// ── Hide duplicate bundle child items in the UpCart drawer ─────────────────

function hideBundleItems(targetNode, bundleParents) {
  if (!targetNode) return;

  var bundleIds = bundleParents.map(function(p) {
    return p.properties['_loop_bundle_id'];
  });

  // Give UpCart DOM time to render
  setTimeout(function() {
    var lineItems = targetNode.querySelectorAll('[data-line-item]');
    lineItems.forEach(function(lineItem) {
      var itemKey = lineItem.getAttribute('data-line-item');
      // Hide child items that belong to a bundle
      var isBundleChild = bundleIds.some(function(bundleId) {
        return itemKey && itemKey.indexOf(bundleId) !== -1;
      });
      if (isBundleChild) {
        lineItem.style.display = 'none';
      }
    });
  }, 300);
}
